import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionHeading } from './SectionHeading';

export function Testimonials() {
  const [active, setActive] = useState(0);
  const testimonial = testimonials[active];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((index) => (index + 1) % testimonials.length);
    }, 3600);

    return () => window.clearInterval(timer);
  }, []);

  const goTo = (direction: number) => {
    setActive((index) => (index + direction + testimonials.length) % testimonials.length);
  };

  return (
    <section className="section-band" id="testimonials">
      <div className="container">
        <SectionHeading
          eyebrow="Testimonials"
          title="Client Testimonials"
          text="Neon-soft cards, avatars, rating stars and smooth transition of the active testimonial."
        />

        <div className="testimonial-card reveal">
          <div className="avatar">{testimonial.avatar}</div>
          <div className="stars" aria-label={`${testimonial.rating} stars`}>
            {Array.from({ length: testimonial.rating }, (_, index) => (
              <Star key={index} size={18} fill="currentColor" />
            ))}
          </div>
          <blockquote>{testimonial.quote}</blockquote>
          <h3>{testimonial.name}</h3>
          <p>{testimonial.role}</p>
          <div className="slider-controls">
            <button type="button" aria-label="Previous testimonial" onClick={() => goTo(-1)}>
              <ChevronLeft size={20} />
            </button>
            <div>
              {testimonials.map((item, index) => (
                <span className={index === active ? 'is-active' : ''} key={item.name} />
              ))}
            </div>
            <button type="button" aria-label="Next testimonial" onClick={() => goTo(1)}>
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
